// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"cf5d063f","453":"09a68e1c"}[chunkId] + ".chunk.js";
};